import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=5e505ea5&scoped=true"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=5e505ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e505ea5",
  null
  
)

export default component.exports